export namespace VCard {
    /** The values of a vCard's `TEL` properties, grouped (`item1.TEL`) or not, as written. */
    export function phoneNumbers(vcard: string): string[] {
        return vcard
            .split(/\r?\n/)
            .filter((line) => /^(?:[^.:;]+\.)?TEL[;:]/i.test(line))
            .map((line) => line.slice(line.indexOf(':') + 1).trim())
            .filter((phoneNumber) => phoneNumber !== '');
    }
}
